import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';
import { ColorScheme } from '../../types/bitkit';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(['card', 'icon']);

type NotificationColorScheme = Exclude<ColorScheme, 'orange' | 'neutral'>;

const colorSchemeToStatus = (colorScheme: NotificationColorScheme) => {
  switch (colorScheme) {
    case 'blue':
      return 'info';
    case 'green':
      return 'success';
    case 'yellow':
      return 'warning';
    case 'red':
      return 'critical';
    case 'purple':
      return 'progress';
  }
};

const getIconColor = ({ colorScheme }: { colorScheme: NotificationColorScheme }) => {
  switch (colorScheme) {
    case 'blue':
      return 'sys/info/base';
    case 'green':
      return 'icon/positive';
    case 'yellow':
      return 'sys/warning/base';
    case 'red':
      return 'icon/negative';
    case 'purple':
      return 'purple.40';
  }
};

const getBackgroundColor = ({ colorScheme }: { colorScheme: NotificationColorScheme }) => {
  return `status/${colorSchemeToStatus(colorScheme)}/bg`;
};

const getBorderColor = ({ colorScheme }: { colorScheme: NotificationColorScheme }) => {
  return `status/${colorSchemeToStatus(colorScheme)}/border`;
};

const getTextColor = ({ colorScheme }: { colorScheme: NotificationColorScheme }) => {
  switch (colorScheme) {
    case 'blue':
      return 'text/primary';
    case 'green':
      return 'text/positive';
    case 'yellow':
      return 'text/primary';
    case 'red':
      return 'text/negative';
    case 'purple':
      return 'text/secondary';
  }
};

const NotificationTheme = defineMultiStyleConfig({
  baseStyle: ({ colorScheme }: { colorScheme: string }) => {
    const cs = colorScheme as NotificationColorScheme;
    return {
      card: {
        bg: getBackgroundColor({ colorScheme: cs }),
        borderColor: getBorderColor({ colorScheme: cs }),
        color: getTextColor({ colorScheme: cs }),
      },
      icon: {
        color: getIconColor({ colorScheme: cs }),
      },
    };
  },
});

export default NotificationTheme;
